import React, {FC} from 'react'
import Button from 'jbc-front/components/Button'
import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {Panel, Body, Head} from 'components/ui/Panel'
import {Breadcrumb} from 'components/layout/Breadcrumb'
import {useFetchPublicApiOAuthStatus} from 'hooks/api/publicApiOAuth/useFetchPublicApiOAuthStatus'

const breadcrumbPaths = [
  {
    key: 'settings',
    to: WITH_AUTH_ADMIN_PATHS.SETTINGS.INDEX,
    label: '設定',
  },
]

export const Index: FC = () => {
  const {resource: status, isLoading} = useFetchPublicApiOAuthStatus()

  return (
    <div>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">API連携</h1>
        <p className="m-title-main-note">一時的に利用できるトークンを発行し、APIを試用できます。</p>
      </div>
      <div className="l-wrap-s l-contents-wrap">
        <Breadcrumb paths={breadcrumbPaths} current="API連携" />

        <Panel className="u-mb30">
          <Head>アクセストークン</Head>
          <Body>
            {isLoading ? (
              '確認中…'
            ) : status?.access_token ? (
              <div>
                <p>アクセストークン: {status.access_token}</p>
                <p>有効期限: {status.expires_at}</p>
              </div>
            ) : (
              '現在有効なアクセストークンはありません。'
            )}
          </Body>
        </Panel>

        <div className="u-ta-c">
          <Button primary onClick={() => (window.location.href = '/api/public-api-oauth/authorize')}>
            アクセストークンを発行
          </Button>
        </div>
      </div>
    </div>
  )
}
